import { render, staticRenderFns } from "./TaxAssessment.vue?vue&type=template&id=a00b1fb0&scoped=true&"
import script from "./TaxAssessment.vue?vue&type=script&lang=ts&"
export * from "./TaxAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00b1fb0",
  null
  
)

export default component.exports